The type of event, i.e. `PositionProfileUpdated`.
